import React, { useState, useEffect } from 'react'
import { Row, ControlLabel, Uploader, Icon, Message, Table, IconButton, ButtonGroup, Whisper, Tooltip } from 'rsuite'
import AttachFilesWidget from './AttachFilesWidget'
import InputForm from '../../components/forms/input/InputForm'
import classNames from 'classnames'
import { isEmpty } from 'lodash-es'
import AppContext from '../../context/AppContext'
import {
  isValidators,
  isRequired,
  getMaxLengthData,
  requiredFiled,
} from '../../utils/ValidatorUtils'

export default function CancelProjectForm({
  schema: _schema,
  attachmentSchema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  hideUpload,
  loading,
  onPreview = () => {},
  onDownload = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [schema, setSchema] = useState(_schema)
  const { theme } = React.useContext(AppContext)

  return (
    <>
      {schema.note && (
        <Row>
          <InputForm
            schema={schema.note}
            rows={3}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Row>
      )}

      <br />

      {/* {!hideUpload &&
        attachmentSchema &&
        attachmentSchema.length > 0 &&
        attachmentSchema.map((item, index) => {
          return (
              <Row key={index}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable'
                    // isRequired(attachmentSchema.validators) && 'required'
                  )}
                >
                  {item.label}
                </ControlLabel>
                <Message
                  style={{ marginTop: 10, marginBottom: 10 }}
                  closable
                  onClose={() => {
                    setFileTypeError(false)
                  }}
                  showIcon
                  type="info"
                  description="ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf, .doc, .docx  ขนาดไฟล์ไม่เกิน 50 MB"
                />

                <Controller
                  name={item.name}
                  control={control}
                  defaultValue={!isEmpty(item.value) ? [item.value] : undefined}
                  // rules={isValidators(attachmentSchema.validators)}
                  render={(props) => {
                    return (
                      <Uploader
                        accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                        draggable
                        autoUpload={false}
                        multiple={false}
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let files = []
                            files.push(fileList[fileList.length - 1])
                            props.onChange(files)
                          }
                        }}
                      >
                        <div>
                          <br />
                          <div className={classNames('uploader', `${theme[0]}-background`)}>
                            <Icon size="4x" icon="upload2" />
                            <br />
                            <br />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด {item.label}
                              </p>
                            </small>
                          </div>
                          <br />
                        </div>
                      </Uploader>
                    )
                  }}
                />
                <br/>
              </Row>
          )
        })
      } */}

      {!hideUpload && attachmentSchema && (
        <>
          <p>เอกสารประกอบการพิจารณา</p>
          <Message
            style={{ marginTop: 10, marginBottom: 10 }}
            showIcon
            type="info"
            description="ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf, .doc, .docx  ขนาดไฟล์ไม่เกิน 50 MB"
          />

          <Table autoHeight height={300} wordWrap bordered data={attachmentSchema}>
            <Column width={90} align="center" fixed>
              <HeaderCell>ไฟล์ที่</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>

            <Column width={500} flexGrow={1}>
              <HeaderCell>ประเภทไฟล์</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return rowData.label
                }}
              </Cell>
            </Column>

            <Column width={250} align="center">
              <HeaderCell>แนบเอกสาร</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (rowData.path) {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={(e) => onPreview(rowData)}
                          disabled={loading}
                        />
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          onClick={(e) => onDownload(rowData)}
                          disabled={loading}
                        />

                        {/* <IconButton
                      disabled={loading || selectEditeIndex == index}
                      icon={<Icon icon="pencil" />}
                      onClick={(e) => handleEditFile(rowData, index)}
                    /> */}
                        {/* {!disabledForm && 
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={(e) => handleDeleteFile(rowData, index)}
                          disabled={!rowData.enableDelete || rowData.isChecked}
                        />} */}
                      </ButtonGroup>
                    )
                  } else {
                    return (
                      <Controller
                        name={rowData.name}
                        control={control}
                        defaultValue={!isEmpty(rowData.value) ? [rowData.value] : undefined}
                        // rules={isValidators(attachmentSchema.validators)}
                        render={(props) => {
                          if (props.value) {
                            console.log('props', props)
                            return (
                              <div
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <p>{props?.value[0]?.name || 'file name'}</p>

                                <IconButton
                                  appearance="link"
                                  //className="rs-btn-ghost-cancel"
                                  icon={<Icon icon="close" style={{ color: 'gray' }} />}
                                  onClick={(e) => {
                                    let files = []
                                    //files.push(fileList[fileList.length - 1])
                                    props.onChange()
                                  }}
                                  //disabled={!rowData.enableDelete || rowData.isChecked}
                                />
                              </div>
                            )
                          } else {
                            return (
                              <Uploader
                                accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                                draggable
                                autoUpload={false}
                                multiple={false}
                                listType="picture"
                                fileList={props.value || []}
                                onChange={(fileList) => {
                                  if (isEmpty(fileList)) {
                                    props.onChange(undefined)
                                  } else {
                                    let files = []
                                    files.push(fileList[fileList.length - 1])
                                    props.onChange(files)
                                  }
                                }}
                              >
                                <button className="upload__button" style={{ marginTop: 0 }}>
                                  <Icon icon="upload" size="lg" />
                                </button>
                                {/* <div>
                          <br />
                          <div className={classNames('uploader', `${theme[0]}-background`)}>
                            <Icon size="4x" icon="upload2" />
                            <br />
                            <br />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด {rowData.label}
                              </p>
                            </small>
                          </div>
                          <br />
                        </div> */}
                              </Uploader>
                            )
                          }
                        }}
                      />
                    )
                  }
                }}
              </Cell>
            </Column>

            <Column width={150} align="center" fixed="right">
            <HeaderCell>ดาวนโหลดไฟล์</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if(rowData?.filePath){
                  let _rowData = {
                      path: rowData.filePath,
                      ...rowData
                  }

                  let fileName = _rowData.path.split("/")[2]
                  console.log('fileName', fileName)
                  return (
                    <ButtonGroup>
                      {/* <IconButton
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={(e) => onPreview(_rowData)}
                        disabled={!_rowData?.path}
                      /> */}
                      <Whisper 
                        placement="bottom" 
                        speaker={
                          <Tooltip style={{fontSize: 15}}>
                            {fileName}
                          </Tooltip>}>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => onDownload(_rowData)}
                        disabled={!_rowData?.path}
                      />
                      </Whisper>
                    </ButtonGroup>
                  )
                } 
              }}
            </Cell>
          </Column>

            {/* {isStaff && !disabledForm && (
              <Column width={210} fixed="right">
                <HeaderCell></HeaderCell>
                <Cell style={{ marginRight: 20 }}>
                  {(rowData) => {
                    if(rowData.path)
                    return (
                      <IconButton
                        icon={
                          <Icon
                            icon="check-circle"
                            style={{ color: (rowData.isChecked || rowData.isValidated) ? '#14997a' : '#8e8e93' }}
                          />
                        }
                        tooltip={`แสดง`}
                        onClick={(e) => handleOnClickCheckFile(rowData)}
                      >
                        บันทึกตรวจสอบไฟล์
                      </IconButton>
                    )
                  }}
                </Cell>
              </Column>
            )} */}
          </Table>
        </>
      )}
    </>
  )
}
